export const environment = {
  production: "true",
  configLocation: 'assets/configurations/config.json'
};